module.exports = __webpack_public_path__ + "static/september-1-9feab810d075030eedbd08bb313187f4.png";